import { render, staticRenderFns } from "./ReservationPage.vue?vue&type=template&id=05a1ddfd&scoped=true"
import script from "./ReservationPage.vue?vue&type=script&lang=js"
export * from "./ReservationPage.vue?vue&type=script&lang=js"
import style0 from "./ReservationPage.vue?vue&type=style&index=0&id=05a1ddfd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05a1ddfd",
  null
  
)

export default component.exports